import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { PricingSection } from "@/components/marketing/PricingSection";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-background">
      <MarketingHeader />
      <main className="pt-16">
        <PricingSection />
      </main>
      <MarketingFooter />
    </div>
  );
}
